import React, { useState, useRef, useEffect } from 'react';
import logo from '../assets/new_logo_selo_redondo.png';
import { Link } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import ReorderIcon from '@mui/icons-material/Reorder';

function NavbarCollapse({ open, id = 'navbarMain', children }) {
  const ref = useRef(null);
  const [height, setHeight] = useState('0px');

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (open) {
      const h = el.scrollHeight;
      setHeight(h + 'px');

      const handleTransitionEnd = () => {
        if (open) setHeight('auto');
      };
      el.addEventListener('transitionend', handleTransitionEnd);
      return () => el.removeEventListener('transitionend', handleTransitionEnd);
    } else {
      if (height === 'auto') {
        const h = el.scrollHeight;
        requestAnimationFrame(() => {
          setHeight(h + 'px');
          requestAnimationFrame(() => setHeight('0px'));
        });
      } else {
        setHeight('0px');
      }
    }
  }, [open]);

  return (
    <div
      id={id}
      ref={ref}
      className={`collapse navbar-collapse ${open ? 'show' : ''}`}
      style={{
        height,
        overflow: 'hidden',
        transition: 'height 300ms ease',
        display: 'block'
      }}
      aria-expanded={open}
    >
      {children}
    </div>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const handleNavClick = () => setOpen(false);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top shadow p-0">
      <div className="container-fluid" style={{ background: "radial-gradient(circle,rgba(98, 191, 239, 1) 0%, rgba(0, 0, 0, 1) 100%)" }}>
        <Link className="navbar-brand" to="/" onClick={handleNavClick}>
          <img src={logo} alt="Reconect" style={{ height: 40 }} />
        </Link>

        <IconButton
          onClick={() => setOpen(!open)}
          aria-label="navegação"
          className="navbar-toggler"
          aria-controls="navbarMain"
          aria-expanded={open}
          style={{ color: "#ffffff" }}
        >
          <ReorderIcon />
        </IconButton>

        <NavbarCollapse open={open}>
          <ul className="navbar-nav me-auto">
             <li className="nav-item">
              <Link className="nav-link text-white fw-bold" to="/" onClick={handleNavClick}>
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link text-white fw-bold" to="/identidade" onClick={handleNavClick}>
                Nossa Identidade
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link text-white fw-bold" to="/servicos" onClick={handleNavClick}>
                Serviços
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link text-white fw-bold" to="/vagas" onClick={handleNavClick}>
                Vagas
              </Link>
            </li>
          </ul>
        </NavbarCollapse>
      </div>
    </nav>
  );
}
